var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"status_ul flex"},_vm._l((_vm.status_list),function(item,index){return _c('li',{key:index,class:_vm.examine_status === item.id ? 'active' : '',on:{"click":function($event){return _vm.statusShow(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }